import React from 'react';
import { Radio, RadioGroup, Text } from 'rsuite';
import { ValueType } from 'rsuite/esm/Radio';
import { PROPERTY_MANAGEMENT_OPTIONS } from 'src/components/payment/constants';
import { ExpressRegistrationRegistrant } from 'src/types/configuration';

interface PropertyManagerRadioGroupProps {
  disabled?: boolean;
  isAdminUpdate?: boolean;
  isOwner?: boolean;
  isPropertyManager: boolean;
  isPropertyManagerDisabled?: boolean;
  onChange: (value: PROPERTY_MANAGEMENT_OPTIONS) => void;
  value: PROPERTY_MANAGEMENT_OPTIONS;
  configuration: ExpressRegistrationRegistrant;
}

export const PropertyManagerRadioGroup = ({
  configuration,
  disabled = false,
  isAdminUpdate = false,
  isOwner = false,
  isPropertyManager,
  isPropertyManagerDisabled = false,
  onChange,
  value,
}: PropertyManagerRadioGroupProps) => {
  const handleChange = (value: ValueType) => {
    onChange(value as PROPERTY_MANAGEMENT_OPTIONS);
  };
  return (
    <>
      <Text>Are you using a Property Manager for this property?</Text>
      <RadioGroup
        name="owner-radio-option-group"
        defaultValue={PROPERTY_MANAGEMENT_OPTIONS.SELF_MANAGED}
        value={value}
        onChange={handleChange}
        disabled={disabled}
      >
        <Radio value={PROPERTY_MANAGEMENT_OPTIONS.SELF_MANAGED}>
          Self Managed
        </Radio>
        {configuration.tenant && (
          <Radio value={PROPERTY_MANAGEMENT_OPTIONS.TENANT}>The tenant</Radio>
        )}
        {!isAdminUpdate && isPropertyManager && !isOwner && (
          <Radio value={PROPERTY_MANAGEMENT_OPTIONS.PROPERTY_MANAGER}>
            I'm the Property Manager
          </Radio>
        )}

        {(isAdminUpdate ||
          (isPropertyManagerDisabled === false &&
            (!isPropertyManager || isOwner))) && (
          <Radio value={PROPERTY_MANAGEMENT_OPTIONS.PROPERTY_MANAGER}>
            Property Manager
          </Radio>
        )}
      </RadioGroup>
    </>
  );
};
